import BucketApiRequest from "./BucketApiRequest";
import { GET_STATUS_URL } from "../ApiUrls";

export default class EmploymentStatusApiRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_STATUS_URL;
  };
}
